import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import { FilterOperatorModel } from '@product/shared/models/filters.interface';
@Component({
  selector: '',
  template: '',
  styles: [],
})
export class MainFilterClass {
  @Input() col: FrontEndColumn;
  private _opr: FilterOperatorModel;
  @Input() set operator(value: FilterOperatorModel) {
    this._opr = value;
  }
  get operator() {
    return this._opr;
  }

  hasError: boolean = false;
  errorMessage: string = '';
  @Output() onModelChange = new EventEmitter();

  _value: any;
  @Input() set value(value: any) {
    if (value == null || value === 'null') {
      this._value = null;
      return;
    }
    if (typeof value == 'string' && [2, 3].includes(this.col.filterType!)) {
      try {
        this._value = JSON.parse(value);
      } catch {
        this._value = value;
      }
    } else {
      this._value = value;
    }
  }
  get value() {
    return this._value;
  }

  onChange(value: any) {
    setTimeout(() => {
      this.onModelChange.emit(this.value);
    }, 500);
  }
}
